const divModalFilterExpiredServices = {
  cancel: 'CANCELAR',
  ok: 'APLICAR',
  mandatory: 'Mostrar Servicios Obligatorios',
  nonMandatory: 'Mostrar Servicios Opcionales',
};

export default divModalFilterExpiredServices;
